export default function transformer(tiersId) {
    let tiersIds = [];
    tiersIds.push(tiersId);
  return {
    skipCount: 0,
    maxResultCount: 9999999,
    query: {tiersIds: tiersIds, dates: {dateDebut: null, dateFin: null}},
  };
}